import Axios from 'axios'
import moment from 'moment'
import config from '../config'
import { debug } from '../utilities/logger'
// import { debug } from '../utilities/logger'

export const getAccount = async () => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/me`
  const response = await Axios.get(URL)
  return response.data
}

export const getPayments = async ({ page } = { page: 0 }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/payments?size=${config.paginate_size}&page=${page}`
  const response = await Axios.get(URL)
  return response.data
}

export const getWallet = async () => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/wallet`
  const response = await Axios.get(URL)
  return response.data
}

export const getRewards = async () => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/reward-history`
  const response = await Axios.get(URL)
  return response.data
}

export const buyCoins = async ({ value, selectedPurchase}) => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/wallet/credit`
  const { host, protocol, pathname } = window.location
  const baseUrl = `${protocol}//${host}${pathname}`
  const successUrl = selectedPurchase ? `${baseUrl}?success&selectedPurchase=${selectedPurchase}` : `${baseUrl}?success`
  const paths = {
    success: successUrl,
    error: `${baseUrl}?error`,
    cancel: `${baseUrl}?cancel`,
    amount: parseFloat(value).toFixed(2)
  }
  const response = await Axios.post(URL, paths)
  if (response.data && response.data.redirect) {
    window.location.replace(response.data.redirect)
  }
}

export const updatePicture = async ({ picture }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/documents/profile-picture`
  const formData = new FormData()
  formData.append('file', picture)
  const response = await Axios.post(URL, formData)
  return response.data
}

export const updateAccount = async ({ account, password, newPassword }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/me`
  const copy = JSON.parse(JSON.stringify(account))
  // Sanitizing phone value
  copy.phone = copy.phone.value || copy.phone
  const params = {
    ...copy,
    password,
    newPassword
  }
  const response = await Axios.put(URL, params)
  return response.data
}

export const getPaymentMandate = async () => {
  const URL = `${config.baseURL}${config.apiURL}payment/sdd/status`
  let status = `SDD_CHECK_FAILURE`
  try {
    const response = await Axios.get(URL)
    status = response.data
  } catch (e) {
    debug(`[api][account.getPaymentMandate] Unable to retrieve sdd status`)
  }
  return {
    status,
    signed: status !== 'SDD_NOT_CREATED',
    valid: status !== 'SDD_NOT_KYC2',
    // SDD_UNAVAILABLE means the mandate can never be prepared, not that it is not ready yet: this
    // customer has no account on the payment platform, so there is nothing to raise to KYC 2.
    // `valid === false` puts up the "send us your ID and your IBAN" block, which would be asking
    // for documents in exchange for nothing — the caller drops the option entirely instead.
    // Note a failed status call yields SDD_CHECK_FAILURE, so we only ever hide on a definite answer.
    available: status !== 'SDD_UNAVAILABLE',
    ready: status === 'SDD_READY'
  }
}

export const getInterventionDate = async () => {
  const URL = `${config.baseURL}${config.apiURL}customers/nextInterventionDate`
  let response = null
  try {
    response = await Axios.get(URL)
  } catch (e) { return null }

  const date = response.data
  if (!date) { return null }
  return {
    date: moment.unix(date).format('DD/MM/YYYY'),
    hours: moment.unix(date).format('HH:mm')
  }
}



// WEBPACK FOOTER //
// ./src/api/account.js